import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {ApprovalPending} from '../../../../shared/dto/approval-pending';
import {ApprovalService} from '../../../../service/approval.service';
import {DispatchSidModel} from '../../../../shared/dto/dispatch-sid.model';

@Component({
  selector: 'app-sid-applicant-data',
  templateUrl: './sid-applicant-data.component.html',
  styleUrls: ['./sid-applicant-data.component.scss']
})
export class SidApplicantDataComponent implements OnInit {
  @Input() sidNo: string;
  applicantSearchForm: FormGroup;
  public approvalPending: ApprovalPending;
  dispatchDto: DispatchSidModel = new DispatchSidModel();
  female: boolean;
  male: boolean;

  constructor(private approvalService: ApprovalService) { }

  ngOnInit() {
    this.applicantSearchForm = new FormGroup({
      appRefNo: new FormControl(null),
      appType: new FormControl(null),
      status: new FormControl(null),
      createDate: new FormControl(null),
      cdcNo: new FormControl(null),
      cocNo: new FormControl(null),
      cdcExpDate: new FormControl(null),
      cocDate: new FormControl(null),
      fullName: new FormControl(null),
      familyName: new FormControl(null),
      givenName: new FormControl(null),
      initialName: new FormControl(null),
      nic: new FormControl(null),
      nicIssueDate: new FormControl(null),
      dob: new FormControl(null),
      gender: new FormControl(null),
      birthPlace: new FormControl(null),
      nationality: new FormControl(null),
      specialCharac: new FormControl(null),
      address: new FormControl(null),
      mobile: new FormControl(null),
      email: new FormControl(null),
    });
    this.onSearch();
  }

  onSearch() {
    this.dispatchDto.sidNo = this.sidNo;
    this.approvalService.searchSidApplicantData(this.dispatchDto).subscribe(
      (data: any ) => {
        this.approvalPending = data;
        this.applicantSearchForm.patchValue(
          {
            remark: this.approvalPending.remark,
            status: this.approvalPending.stage,
            appType: this.approvalPending.type,
            nic: this.approvalPending.nic,
            createDate: this.approvalPending.createdDate,
            fullName: this.approvalPending.name,
            appRefNo: this.approvalPending.appRefNo,
            cdcNo: this.approvalPending.cdcNo,
            cocNo: this.approvalPending.cocNo,
            cdcExpDate: this.approvalPending.cdcExpDate,
            cocDate: this.approvalPending.cocDate,
            familyName: this.approvalPending.familyName,
            givenName: this.approvalPending.givenName,
            initialName: this.approvalPending.initialName,
            nicIssueDate: this.approvalPending.nicIssueDate.toString().substring(0, 10),
            dob: this.approvalPending.dob.toString().substring(0, 10),
            gender: this.approvalPending.gender,
            birthPlace: this.approvalPending.birthPlace,
            nationality: this.approvalPending.nationality,
            specialCharac: this.approvalPending.specialCharac,
            address: this.approvalPending.address,
            mobile: this.approvalPending.mobile,
            email: this.approvalPending.email,
          }
        );

        if (this.approvalPending.gender === 'Male') {
          this.male = true;
          this.female = false;
        }
        if (this.approvalPending.gender === 'Female') {
          this.male = false;
          this.female = true;
        }
      }
    );
  }

}
